import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class StepperService {
	private readonly _currentStep: BehaviorSubject<number> = new BehaviorSubject(0)
	// eslint-disable-next-line @typescript-eslint/member-ordering
	public readonly currentStep$: Observable<number> = this._currentStep.asObservable()

	constructor () { }

	public updateStep (step: number): void {
		this._currentStep.next(step)
	}
}
